export default "__VITE_ASSET__ac63adf7__"